/**
 * Collect all transferrable objects (currently only ArrayBuffers) from a value, recursively. This allows us
 *  to transfer large data structures without copying them, while still supporting nested objects and arrays.
 * Note that we have to be careful to only include ArrayBuffers that are actually being sent,
 *  otherwise we might accidentally transfer buffers that are still in use by the main thread, thus zeroing them out.
 * @param value The value being sent to/from the worker.
 * @returns The list of transferrable objects contained in the value.
 */
export function collectTransferables(value: unknown): Transferable[] {
	if (value instanceof ArrayBuffer) {
		return [value];
	}
	if (!value || typeof value !== "object") {
		return [];
	}
	if (Array.isArray(value)) {
		return value.flatMap((item) => collectTransferables(item));
	}
	return Object.values(value).flatMap((item) => collectTransferables(item));
}
